import { useEffect, useState, useRef } from 'react';
import styles from './NamespaceDropdown.module.css';
import NaviButton from '../NaviButton';
import useApi from '../../services/useApi';
import { useRecoilState } from 'recoil';
import { namespaceState,namespaceDetailState } from '../../recoil/atoms';

export default function NamespaceDropdown({onSearch,onHow}){
  const [isNamespace,setIsNamespace]=useState(false);
  const [nsList,setNsList]=useState(null);
  const [nsState,setNsState]=useRecoilState(namespaceState);
  const [nsDetailState,setNsDetailState]=useRecoilState(namespaceDetailState);
  const [nowNamespace,setNowNamespace]=useState(null);
  const [defaultNsId,setDefaultNsId]=useState("");
  const bodyRef=useRef(null);

  const handleNsClick=()=>{
    setIsNamespace(!isNamespace)
    useApi.get('ngp/namespace/registered/list').then((res)=>{
      setNsList(res.data);
    })
  }

  const updateNsDetail=(updateNs)=>{
    useApi.get('ngp/namespace/info?namespaceId='+updateNs.id).then((res)=>{
      setNsDetailState(res.data);
    })
  }

  useEffect(()=>{
    useApi.get('ngp/namespace/registered/list').then((res)=>{
      setNsList(res.data);

      if(nsState.id==""){
        const defaultNs=res.data.find(item=>item.defaultYN==="Y");
        setNowNamespace(defaultNs.namespaceName)
        setNsState(defaultNs);
        updateNsDetail(defaultNs);
      }
      else{
        setNowNamespace(nsState.namespaceName)
      }

      const findedNsId=nsState.id;
      setDefaultNsId(findedNsId);

    })

    function handleClickOutside(event) {
      if (bodyRef.current && !bodyRef.current.contains(event.target)) {
        setIsNamespace(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  },[])

  useEffect(()=>{
    if(nsList==null)return;
    const defaultNs=nsList.find(item=>item.namespaceName===nowNamespace);
    setNsState(defaultNs);
    setNowNamespace(defaultNs.namespaceName)
    updateNsDetail(defaultNs);
  },[nowNamespace])

  return(
    <div className={`${styles['namespace-dropdown']} ${isNamespace&&styles['namespace-dropdown-hover']}`}
    onClick={handleNsClick}
    ref={bodyRef}
    >
      <span>{nowNamespace}</span>
      <div className={`${styles['namespace-dropdown-arrow']} ${isNamespace&&styles['namespace-dropdown-arrow-on']}`}>&gt;</div>
      <div className={styles['menu-tip']}>Namespace - {nowNamespace}</div>
      {isNamespace&&
      <div className={styles['namespace-dropdown-body']}>
        {Object.values(nsList).map(value=>
        <div 
        className={`${styles['namespace-dropdown-item']} ${value.namespaceName==nowNamespace&&styles['namespace-dropdown-item-hover']}`}
        onClick={()=>setNowNamespace(value.namespaceName)}>
          <span>{value.namespaceName}</span>
          {value.namespaceUserRoleName=="owner"&&<label>Owner</label>}
        </div>
        )}
        <hr></hr>
        <div className={styles['namespace-dropdown-item']}>
          <div className={styles['namespace-dropdown-dashboard']}></div>
          <span>Dashboard</span>
        </div>
        <NaviButton to="/namespace-setting-general" className={styles['namespace-dropdown-item']}>
          <div className={styles['namespace-dropdown-settings']}></div>
          <span>Settings</span>
        </NaviButton>
        <div className={styles['namespace-dropdown-item']} onClick={()=>onSearch()}>
          <div className={styles['namespace-dropdown-search']}></div>
          <span>Join Namespace</span>
        </div>
        <div className={styles['namespace-dropdown-item']} onClick={()=>onHow()}>
          <div className={styles['namespace-dropdown-how']}></div>
          <span>How to create</span>
        </div>
      </div>
      }
    </div>
  )
}